// file only for hot reloader
// entry points used in production can be seen in .neutrino.js
import './main';
